import { useEffect, useRef, useState } from 'react';

const POPUP_PAPER_SELECTOR = '.custom-dialog-right';
const POPUP_ENTER_FALLBACK_MS = 100;

const prefersReducedMotion = () => globalThis.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;

export const useDeferUntilPopupEntered = () => {
    const containerRef = useRef(null);
    const [isPopupEntered, setIsPopupEntered] = useState(false);

    useEffect(() => {
        if (prefersReducedMotion()) {
            setIsPopupEntered(true);
            return;
        }

        const paper = containerRef.current?.closest(POPUP_PAPER_SELECTOR);
        if (!paper) {
            setIsPopupEntered(true);
            return;
        }

        let isSettled = false;

        const markEntered = () => {
            if (isSettled) {
                return;
            }

            isSettled = true;
            setIsPopupEntered(true);
        };

        const handleTransitionEnd = event => {
            if (event.target === paper && event.propertyName.includes('transform')) {
                markEntered();
            }
        };

        paper.addEventListener('transitionend', handleTransitionEnd);
        const fallbackTimeout = setTimeout(markEntered, POPUP_ENTER_FALLBACK_MS);

        return () => {
            paper.removeEventListener('transitionend', handleTransitionEnd);
            clearTimeout(fallbackTimeout);
        };
    }, []);

    return { containerRef, isPopupEntered };
};
